<template>
  <div
    v-if="showVideoOverlay"
    ref="videoOverlay"
    class="video-overlay"
    @click.stop
  >
    <div class="video-overlay__content">
      <video
        v-if="isDirectVideo"
        ref="videoPlayer"
        class="video-overlay__media"
        :src="videoUrl"
        controls
        autoplay
        playsinline
      />
      <iframe
        v-else
        class="video-overlay__media"
        :src="embedVideoUrl"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      />
      <button class="video-overlay__close" @click.stop="closeVideo">×</button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    useFullscreen() {
      return this.$device.isMobile || this.$device.isTablet;
    },
    videoUrl() {
      return this.$store.state.env.previewVideoUrl;
    },
    showVideoOverlay() {
      return !!this.videoUrl;
    },
    isDirectVideo() {
      return /\.(mp4|webm|ogg)(\?|#|$)/i.test(this.videoUrl);
    },
    embedVideoUrl() {
      if (!this.videoUrl) return '';

      const youtubeMatch = this.videoUrl.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/i
      );
      if (youtubeMatch?.[1]) {
        return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1&rel=0`;
      }

      const vimeoMatch = this.videoUrl.match(/vimeo\.com\/(\d+)/i);
      if (vimeoMatch?.[1]) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
      }

      return this.videoUrl;
    },
  },
  methods: {
    closeVideo() {
      if (
        this.useFullscreen &&
        document.fullscreenElement &&
        document.exitFullscreen
      ) {
        document.exitFullscreen().catch(() => null);
      }
      const videoEl = this.$refs.videoPlayer;
      if (videoEl && !videoEl.paused) {
        videoEl.pause();
      }
      this.$store.dispatch('env/closePreviewModal');
    },
    isDesktopDevice() {
      if (typeof window === 'undefined' || !window.matchMedia) {
        return true;
      }
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

.video-overlay__content {
  position: relative;
  width: min(90vw, 960px);
  aspect-ratio: 16 / 9;
  max-height: 80vh;
}

.video-overlay__media {
  width: 100%;
  height: 100%;
  border: 0;
  background: #000;
}

.video-overlay__close {
  position: absolute;
  left: 100%;
  top: -5px;
  width: 40px;
  height: 40px;
  font-size: 40px;
  line-height: 1;
  color: $white;
  cursor: pointer;
  background: transparent;
  border: 0;
}

@media (hover: none), (pointer: coarse) {
  .video-overlay__content {
    width: min(100vw, 1400px);
    height: min(100vh, 788px);
    max-height: none;
  }
}
</style>
